export const STORY_SLUG = "rebuilding-langwatch-in-51-days"
